var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOpendockIcon = function SvgOpendockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28.16 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#opendock-icon_svg__a)",
    fill: "#0E4059"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.263 1.993 24.08 10.02v16.075l3.447-2.007V8.026L13.71 0l-3.447 1.993Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.216 4.934 13.757 7.983v16.147l3.443-2.003v-16.07L8.579 2.973l-3.363 1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.099 7.912 13.813 8.026L13.917 32l3.386-1.95V13.916L3.546 5.905.1 7.912Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.393 24.85 11.02 6.402V18.443L1.392 24.85ZM0 9.607v14.31l3.448-2.003V11.61L0 9.607ZM1.355 1.628h.508c.23 0 .385-.143.385-.365 0-.218-.155-.365-.386-.365h-.507v.73Zm.93 1.16-.564-.957h-.366v.957h-.207V.695h.715c.409 0 .592.28.592.568 0 .27-.155.52-.498.559l.569.96h-.24v.006ZM.208 1.74a1.523 1.523 0 0 1 3.043 0 1.522 1.522 0 0 1-3.043 0Zm-.207 0c0 .952.771 1.724 1.726 1.724a1.724 1.724 0 1 0 0-3.447C.771.018 0 .789 0 1.74Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "opendock-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28.16v32H0z"
  })))));
};

export default SvgOpendockIcon;